import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, encodedStringParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
export const SHOW_DROP_DOWN_MENU_PAYLOAD_DEFINITION = {
    isRawParam: true,
    definitionParts: [{ name: 'dropDownMenus', parser: createArrayWithBracesParser(dropDownMenuParser) }]
};
const dropDownMenuPartDefinitions = [
    { name: 'label', parser: stringParser },
    { name: 'iconName', parser: stringParser },
    { name: 'dropDownMenuItems', parser: createArrayWithBracesParser(dropDownMenuItemParser) }
];
function dropDownMenuParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, dropDownMenuPartDefinitions);
}
const dropDownMenuItemPartDefinitions = [
    { name: 'label', parser: stringParser },
    { name: 'iconName', parser: stringParser },
    { name: 'action', parser: encodedStringParser },
    { name: 'data', parser: encodedStringParser }
];
function dropDownMenuItemParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, dropDownMenuItemPartDefinitions);
}
